import { render, staticRenderFns } from "./HouseBoat.vue?vue&type=template&id=15c83f64&scoped=true"
import script from "./HouseBoat.vue?vue&type=script&lang=js"
export * from "./HouseBoat.vue?vue&type=script&lang=js"
import style0 from "./HouseBoat.vue?vue&type=style&index=0&id=15c83f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c83f64",
  null
  
)

export default component.exports